var store = {
  debug: true,
  state: {
    persons: [],
    images: [],
    user: {
      uid: undefined,
      lastInvalidatedTopPicks: undefined,
    },
  },
  overridePersons(persons) {
    if(this.debug) console.log('overriding persons');
    this.state.persons = persons;
  },
  overrideImages(images) {
    if(this.debug) console.log('overriding images');
    this.state.images = images;
  },
  addPerson(person) {
    if(this.debug) console.log('adding person');
    this.state.persons.push(person);
  },
  overrideUser(user) {
    if(this.debug) console.log(`overriding uid ${user.uid}`);
    this.state.user = user;
  },
  overrideLastInavlidatedTopPicks(date) {
    if(this.debug) console.log(`overriding lastInvalidatedTopPicks to ${date}`);
    this.state.user.lastInvalidatedTopPicks = date;
  }
}

export default store;
